import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Row, Col, Table, Icon, Button } from 'antd'
import { groupPolicyProviders } from '@services/api'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class List extends Component<any> {
    handleEditCompany = async data => {
        const relatedPolicies = (await groupPolicyProviders.relatedPolicies({ id: data.id })).data
        const relatedUsers = (await groupPolicyProviders.relatedUsers({ id: data.id })).data
        this.props.popupStore.togglePopup('editProvider', { ...data, relatedPolicies, relatedUsers })
    }

    render() {
        const { list, loading } = this.props

        const columns = [
            {
                title: 'עריכת מעסיק',
                key: 'edit',
                width: 150,
                render: (_, record) => (
                    <Button onClick={() => this.handleEditCompany({ id: record.id, name: record.name })}>
                        <Icon type="edit" />
                    </Button>
                )
            },
            {
                title: 'שם המעסיק',
                key: 'name',
                align: 'right',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: 'מזהה מעסיק',
                key: 'id',
                width: 200,
                render: (_, record) => <span>{record.id}</span>
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            columns={columns}
                            rowClassName={() => style.user_row}
                            dataSource={list}
                            pagination={{
                                pageSize: 10
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRouter(List)
